import { createFileRoute } from '@tanstack/react-router';

import HomePage from '@/pages/home/HomePage';
import { withHomeSearchAnswers } from '@/pages/home/utils/home-search-answers';
import { getFooterLandingPages, getHomePage } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { getLandingPageFaqs } from '@/utils/landing-page-faqs';
import {
  buildFaqPageSchema,
  buildOrganizationSchema,
  buildPageMeta,
  buildStructuredDataScript,
  siteName,
  siteUrl,
} from '@/utils/seo';

export const Route = createFileRoute('/')({
  loader: async () => {
    const [homePage, footerLandingPages, footerLegalLinks] = await Promise.all([
      getHomePage(),
      getFooterLandingPages(),
      getLegalLinks(),
    ]);
    // A 5xx (unlike a 404) tells crawlers the outage is temporary.
    if (!homePage) {
      throw new Error('The home page is missing from Sanity');
    }

    return {
      footerLandingPages,
      footerLegalLinks,
      homePage: withHomeSearchAnswers(homePage),
    };
  },
  component: HomePage,
  head: ({ loaderData }) => {
    const pageMeta = buildPageMeta({
      title: loaderData?.homePage.seoTitle ?? siteName,
      description:
        loaderData?.homePage.seoDescription ??
        'Compare local letting agents with Budgy.',
      path: '/',
    });
    const faqs = getLandingPageFaqs(loaderData?.homePage);

    return {
      ...pageMeta,
      scripts: [
        buildStructuredDataScript({
          '@context': 'https://schema.org',
          '@graph': [
            buildOrganizationSchema(),
            {
              '@type': 'WebSite',
              '@id': `${siteUrl}/#website`,
              name: siteName,
              url: siteUrl,
              publisher: { '@id': `${siteUrl}/#organization` },
            },
          ],
        }),
        ...(faqs.length > 0
          ? [buildStructuredDataScript(buildFaqPageSchema(faqs))]
          : []),
      ],
    };
  },
});
